import { graphql } from 'gatsby';
import FooterLinksGroup from '../FooterLinksGroup/FooterLinksGroup';
import { StyledColumn } from './FooterColumn.styles';

const Column = ({ footerColumnElements: elements }: Queries.FOOTER_COLUMNFragment) => {
  const { link_groups } = elements;

  return (
    <StyledColumn>
      {link_groups.value.map((group) => (
        <FooterLinksGroup key={group.id} {...group} />
      ))}
    </StyledColumn>
  );
};

export default Column;

export const fragment = graphql`
  fragment FOOTER_COLUMN on kontent_item_footer_column {
    id
    footerColumnElements: elements {
      link_groups {
        value {
          ...FOOTER_LINKS_GROUP
        }
      }
    }
  }
`;
